// apps/agent-studio/src/shared/analytics/standard-props.ts
export function currentRoute(): string {
  return window.location.pathname;
}
